/** --------------- FINAL WORKING LOGIN --------------- **/
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast';
import axios from 'axios';
import { M_STORE, PAY, PMS, V_URL } from '../../../BaseUrl';
import cryptojs from 'crypto-js'
import { useRoleAccess } from '../../../Context/RoleAccessContext';
import Images from '../../../Images/Img';
import moment from 'moment';

const Login = () => {

    const [login, setLogin] = useState({ email: "", password: "", pwdShow: true, remember: false });
    const [newData, setNewData] = useState({ email: "", product: "", erp_role: "", project: "", year: '', firm: '' });
    const [step, setStep] = useState(1);

    const [projectData, setProjectData] = useState([]);
    const [erpData, setErpData] = useState([]);
    const [yearData, setYearData] = useState([]);
    const [firmData, setFirmData] = useState([]);

    const [disable, setDisable] = useState(false);
    const [error, setError] = useState({});
    const [errorTwo, setErrorTwo] = useState({});

    const navigate = useNavigate();
    const location = useLocation();
    const secretKey = 'Vishal Enterprise';
    const { setUserRole } = useRoleAccess();

    // Get login type from location state or URL
    const loginType = location?.state?.type ? "MAIN_STORE" : "PMS";

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_REMEMBER_ME') === 'true') {
            const password = cryptojs.AES.decrypt(localStorage.getItem('PAY_USER_PASSWORD'), secretKey);
            const decryptedPassword = password.toString(cryptojs.enc.Utf8);

            setLogin({
                email: localStorage.getItem('PAY_USER_EMAIL'),
                password: decryptedPassword,
                remember: true,
                pwdShow: true
            });
        }
    }, []);

    const handleChange = (e) => {
        setLogin({ ...login, [e.target.name]: e.target.value });
    };

    const handleChangeTwo = (e) => {
        setNewData({ ...newData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validation()) return;

        setDisable(true);
        const myurl = `${V_URL}/user/login`;

        const bodyFormData = new URLSearchParams();
        bodyFormData.append('email', login.email);
        bodyFormData.append('password', login.password);

        axios({
            method: "post",
            url: myurl,
            data: bodyFormData,
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
        }).then((response) => {

            const data = response.data.data;

            if (data.product === PAY) {
                toast.error("Please select Payroll login.");
                setDisable(false);
                return;
            }

            if (response.data.success === true) {

                // Check if user credentials match the selected login type
                if (loginType === "MAIN_STORE" && data.product !== M_STORE) {
                    toast.error("Invalid Credentials");
                    setDisable(false);
                    return;
                }

                if (loginType === "PMS" && data.product !== PMS) {
                    toast.error("Invalid Credentials");
                    setDisable(false);
                    return;
                }

                localStorage.setItem('VI_PRO', data.product);
                localStorage.setItem('PAY_USER_TOKEN', data.token);
                localStorage.setItem('PAY_USER_NAME', data.name);
                localStorage.setItem('PAY_USER_ID', data.id);
                localStorage.setItem('PAY_USER_EMAIL', data.email);

                setFirmData(data.firm || []);
                setYearData(data.year || []);
                setProjectData(data.project || []);
                setErpData(data.erpRole || []);

                setNewData({
                    email: data.email,
                    product: data.product,
                    firm: data.firm?.length === 1 ? data.firm[0]._id : '',
                    year: data.year?.length === 1 ? data.year[0]._id : '',
                    project: '',
                    erp_role: ''
                });

                toast.success(response.data.message);

                // MAIN STORE Login Flow
                if (data.product === M_STORE) {

                    if (!data.firm?.length || !data.year?.length) {
                        toast.error("Firm or Year not found for Main Store.");
                        setDisable(false);
                        return;
                    }

                    // Condition: If there is only one firm and one year, auto select and navigate directly
                    if (data.firm.length === 1 && data.year.length === 1) {
                        const firstFirm = data.firm[0];
                        const firstYear = data.year[0];

                        localStorage.setItem('PAY_USER_YEAR_ID', firstYear?._id);
                        localStorage.setItem('PAY_USER_FIRM_ID', firstFirm?._id);
                        localStorage.setItem('PAY_USER_FIRM_NAME', firstFirm?.name);
                        localStorage.setItem('PAY_USER_START_YEAR', firstYear?.start_year);
                        localStorage.setItem('PAY_USER_END_YEAR', firstYear?.end_year);

                        navigate('/main-store/user/dashboard');
                        setDisable(false);
                        return;
                    }

                    // Multiple options available: let user select firm and year manually
                    setStep(2);
                    setDisable(false);
                    return;
                }

                // PMS Login Flow
                if (data.product === PMS) {
                    if (!data.project?.length) {
                        toast.error("No projects assigned to this user.");
                        setDisable(false);
                        return;
                    }
                    setStep(2);
                    setDisable(false);
                    return;
                }
            }

        }).catch((error) => {
            toast.error(error?.response?.data?.message || 'Login failed');
            setDisable(false);
        });

        /** SAVE LOGIN */
        if (login.remember) {
            localStorage.setItem('PAY_USER_EMAIL', login.email);
            localStorage.setItem('PAY_USER_PASSWORD', cryptojs.AES.encrypt(login.password, secretKey).toString());
            localStorage.setItem('PAY_USER_REMEMBER_ME', true);
        } else {
            localStorage.setItem('PAY_USER_REMEMBER_ME', false);
        }
    };

    // STEP 2 — PMS & MAIN STORE SIGN IN
    const handleSignIn = (e) => {
        e.preventDefault();

        if (newData.product === PMS) {
            if (!validationTwo()) return;

            setDisable(true);

            const selectedProject = projectData.find(p => p._id === newData.project);

            if (selectedProject?.is_completed) {
                toast.error("Project is completed.");
                setDisable(false);
                return;
            }

            /** Save PMS selections */
            localStorage.setItem('U_PROJECT_ID', selectedProject?._id);
            localStorage.setItem('U_PROJECT_NO', selectedProject?.project_no);
            localStorage.setItem('PAY_USER_FIRM_ID', selectedProject?.firm_id?._id);
            localStorage.setItem('PAY_USER_YEAR_ID', selectedProject?.year_id?._id);
            localStorage.setItem('ERP_ROLE', newData.erp_role);

            setUserRole(newData.erp_role);

            toast.success("Login Successful");
            navigate('/user/project-store/dashboard');
            setDisable(false);
        } else if (newData.product === M_STORE) {
            if (!validationTwoStore()) return;

            setDisable(true);

            const selectedFirm = firmData.find(f => f._id === newData.firm);
            const selectedYear = yearData.find(y => y._id === newData.year);

            localStorage.setItem('PAY_USER_FIRM_ID', newData.firm);
            localStorage.setItem('PAY_USER_YEAR_ID', newData.year);
            if (selectedFirm?.name) {
                localStorage.setItem('PAY_USER_FIRM_NAME', selectedFirm.name);
            }
            if (selectedYear?.start_year) {
                localStorage.setItem('PAY_USER_START_YEAR', selectedYear.start_year);
                localStorage.setItem('PAY_USER_END_YEAR', selectedYear.end_year);
            }

            toast.success("Login Successful");
            navigate('/main-store/user/dashboard');
            setDisable(false);
        }
    };

    const validation = () => {
        let err = {};
        let valid = true;

        if (!login.email) { err.email_err = "Enter email"; valid = false; }
        if (!login.password) { err.password_err = "Enter password"; valid = false; }

        setError(err);
        return valid;
    };

    const validationTwo = () => {
        let err = {};
        let valid = true;

        if (projectData.length > 0 && !newData.project) {
            err.project_err = "Select Project";
            valid = false;
        }
        if (projectData.length > 0 && !newData.erp_role) {
            err.erp_role_err = "Select ERP Role";
            valid = false;
        }

        setErrorTwo(err);
        return valid;
    };

    const validationTwoStore = () => {
        let err = {};
        let valid = true;

        if (!newData.firm) {
            err.firm_err = "Select Firm";
            valid = false;
        }
        if (!newData.year) {
            err.year_err = "Select Year";
            valid = false;
        }

        setErrorTwo(err);
        return valid;
    };

    return (
        <div className="main-wrapper login-body">
            <div className="container-fluid px-0">
                <div className="row">
                    <div className="col-lg-6 login-wrap">
                        <div className="login-sec">
                            <div className="log-img">
                                <img className="img-fluid" src="/assets/img/login-img.png" alt="Logo" />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 login-wrap-bg">
                        <div className="login-wrapper">
                            <div className="loginbox">
                                <div className="login-right">
                                    <div className="login-right-wrap">
                                        <div className="account-logo login-vlogo">
                                            <Link to="/user/login"><img src={Images.Logo} alt="account-logo" /></Link>
                                        </div>

                                        {step === 1 ? (
                                            <>
                                                <h2>{loginType === "MAIN_STORE" ? "Main Store Login" : "PMS Login"}</h2>

                                                <form onSubmit={handleSubmit}>
                                                    <div className="input-block">
                                                        <label>Email *</label>
                                                        <input className="form-control"
                                                            name='email'
                                                            value={login.email}
                                                            onChange={handleChange}
                                                        />
                                                        <div className='error'>{error.email_err}</div>
                                                    </div>

                                                    <div className="input-block position-relative">
                                                        <label>Password *</label>

                                                        <input className="form-control"
                                                            type={login.pwdShow ? "password" : "text"}
                                                            name='password'
                                                            value={login.password}
                                                            onChange={handleChange}
                                                        />

                                                        <div className="profile-views toggle-password"
                                                            onClick={() => setLogin({ ...login, pwdShow: !login.pwdShow })}
                                                        >
                                                            <i className={`fa-solid ${login.pwdShow ? "fa-eye" : "fa-eye-slash"}`} />
                                                        </div>

                                                        <div className='error'>{error.password_err}</div>
                                                    </div>

                                                    <div className="forgotpass">
                                                        <label className="custom_check">
                                                            Remember me
                                                            <input type="checkbox"
                                                                checked={login.remember}
                                                                onChange={() => setLogin({ ...login, remember: !login.remember })}
                                                            />
                                                            <span className="checkmark" />
                                                        </label>

                                                        <Link to="/user/forget-password">Forgot Password?</Link>
                                                    </div>

                                                    <button className="btn btn-primary btn-block" disabled={disable}>
                                                        {disable ? "Processing..." : "Continue"}
                                                    </button>
                                                </form>

                                                <p className="account-subtitle mt-5">
                                                    Back To <Link to="/">Main Login</Link> 
                                                </p>
                                            </>
                                        ) : null}


                                        {step === 2 && newData.product === PMS ? (
                                            <>
                                                <h2>Select Project & Role</h2>

                                                <form onSubmit={handleSignIn}>

                                                    <div className="input-block">
                                                        <label>Project *</label>
                                                        <select
                                                            className="form-control"
                                                            name="project"
                                                            value={newData.project}
                                                            onChange={handleChangeTwo}
                                                        >
                                                            <option value="">Select Project</option>

                                                            {projectData.map((p) => (
                                                                <option key={p._id} value={p._id}>{p.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="error">{errorTwo.project_err}</div>
                                                    </div>

                                                    <div className="input-block">
                                                        <label>ERP Role *</label>
                                                        <select
                                                            className="form-control"
                                                            name="erp_role"
                                                            value={newData.erp_role}
                                                            onChange={handleChangeTwo}
                                                        >
                                                            <option value="">Select Role</option>

                                                            {erpData.map((e) => (
                                                                <option key={e._id} value={e.name}>{e.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="error">{errorTwo.erp_role_err}</div>
                                                    </div>

                                                    <button className="btn btn-primary btn-block" disabled={disable}>
                                                        {disable ? "Processing..." : "Sign In"}
                                                    </button>

                                                </form>

                                                <p className="account-subtitle mt-5">
                                                    Back To <Link to="/">Main Login</Link> 
                                                </p>
                                            </>
                                        ) : null}

                                        {step === 2 && newData.product === M_STORE ? (
                                            <>
                                                <h2>Select Firm & Year</h2>

                                                <form onSubmit={handleSignIn}>

                                                    <div className="input-block">
                                                        <label>Firm *</label>
                                                        <select
                                                            className="form-control"
                                                            name="firm"
                                                            value={newData.firm}
                                                            onChange={handleChangeTwo}
                                                        >
                                                            <option value="">Select Firm</option>

                                                            {firmData.map((f) => (
                                                                <option key={f._id} value={f._id}>{f.name}</option>
                                                            ))}
                                                        </select>
                                                        <div className="error">{errorTwo.firm_err}</div>
                                                    </div>

                                                    <div className="input-block">
                                                        <label>Year *</label>
                                                        <select
                                                            className="form-control"
                                                            name="year"
                                                            value={newData.year}
                                                            onChange={handleChangeTwo}
                                                        >
                                                            <option value="">Select Year</option>

                                                            {yearData.map((y) => (
                                                                <option key={y._id} value={y._id}>
                                                                    {moment(y?.start_year).format('YYYY')}-{moment(y?.end_year).format('YYYY')}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="error">{errorTwo.year_err}</div>
                                                    </div>

                                                    <button className="btn btn-primary btn-block" disabled={disable}>
                                                        {disable ? "Processing..." : "Sign In"}
                                                    </button>

                                                </form>

                                                <p className="account-subtitle mt-5">
                                                    Back To <Link to="/">Main Login</Link> 
                                                </p>
                                            </>
                                        ) : null}

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Login;